class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.mode = this.getAttribute('data-mode') === 'loop' ? 'loop' : 'date';
    this.duration = parseInt(this.getAttribute('data-duration'), 10) || 0;
    this.endTime = this.#parseEnd(this.getAttribute('data-end'));
    this.daysLabel = this.getAttribute('data-days-label') || 'd';

    if (this.mode === 'loop' ? this.duration <= 0 : !this.endTime) {
      this.hidden = true;
      return;
    }
    if (this.mode === 'loop') {
      this.loopStart = Date.now();
    }
    this.#tick();
    this.interval = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  #parseEnd(value) {
    if (!value) return null;
    const normalized = value.trim().replace(' ', 'T');
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date.getTime();
  }

  #tick() {
    let remaining;

    if (this.mode === 'loop') {
      // Evergreen timer: starts at the full duration when displayed, counts
      // down to zero, then restarts.
      let elapsed = Date.now() - this.loopStart;
      if (elapsed >= this.duration * 1000) {
        this.loopStart = Date.now();
        elapsed = 0;
      }
      remaining = this.duration * 1000 - elapsed;
      this.#render(remaining);
      return;
    }

    remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.textContent = '00:00:00';
      const host = this.closest('[data-countdown-host]');
      if (host) {
        host.classList.add('countdown-expired');
      } else {
        // No host to hide (e.g. the drawer banner): hide the timer itself.
        this.hidden = true;
      }
      return;
    }

    this.#render(remaining);
  }

  #render(remaining) {
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => String(n).padStart(2, '0');

    // Leading units that are unused are hidden (e.g. 14:32, not 00:14:32).
    if (days > 0) {
      this.textContent = `${days}${this.daysLabel} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else if (hours > 0) {
      this.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    } else {
      this.textContent = `${pad(minutes)}:${pad(seconds)}`;
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
